import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { AdministratorLoginShortingBlackoutDatesForm } from './LoginShortingBlackoutDatesForm';
import { Button } from "@progress/kendo-react-buttons";
import { CommandCell } from '../../forms/CommandCell';
import {
    Grid,
    GridColumn as Column,
    GridToolbar,
} from "@progress/kendo-react-grid";

import './Login.scss';

export const AdministratorLoginShortingBlackoutDates = (props) => {
    const dispatch = useDispatch();

    const [loginShortingBlackoutDates, setLoginShortingBlackoutDates] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [editItem, setEditItem] = useState(undefined);
    const [loadingError, setLoadingError] = useState("");
    const [ticketingWebsites, setTicketingWebsites] = useState([]);
    const [openForm, setOpenForm] = useState(false);

    const getTicketingWebsites = () => {
        const dataItem = {
            onlyActive: true,
        }

        fetch(`/api/general/ticketingwebsites`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setTicketingWebsites(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const getLoginShortingBlackoutDates = () => {
        setIsLoading(true);

        const dataItem = {
            loginKey: props.loginKey,
        };

        fetch(`/api/administrator/readloginshortingblackoutdates`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setIsLoading(false);
                setLoginShortingBlackoutDates(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setIsLoading(false);
                setLoadingError(error.message);
            });
    }

    const addLoginShortingBlackoutDates = (dataItem) => {
        fetch("/api/administrator/loginshortingblackoutdates",
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setOpenForm(false);

                addNotificationWithTimeout(dispatch, "success", "Created item successfully");

                getLoginShortingBlackoutDates();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const updateLoginShortingBlackoutDates = (dataItem) => {
        fetch("/api/administrator/loginshortingblackoutdates",
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setOpenForm(false);

                addNotificationWithTimeout(dispatch, "success", "Updated item successfully");

                getLoginShortingBlackoutDates();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const deleteLoginShortingBlackoutDates = (loginShortingBlackoutDatesKey) => {
        const dataItem = {
            loginShortingBlackoutDatesKey: loginShortingBlackoutDatesKey
        }

        fetch("/api/administrator/loginshortingblackoutdates",
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Deleted item successfully");

                getLoginShortingBlackoutDates();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const remove = (dataItem) => {
        deleteLoginShortingBlackoutDates(dataItem.loginShortingBlackoutDatesKey);
    };

    const MyCommandCell = (props) => (
        <CommandCell
            {...props}
            edit={enterEdit}
            remove={remove}
        />
    );

    const save = (dataItem) => {
        //Perform validation  
        if (!dataItem.dates.start) {
            addNotificationWithTimeout(dispatch, "error", "The begin date is invalid");
            return;
        }

        if (!dataItem.dates.end) {
            addNotificationWithTimeout(dispatch, "error", "The end date is invalid");
            return;
        }

        if (!dataItem.loginKey) {
            dataItem.loginKey = props.loginKey;
        }

        dataItem.beginDate = dataItem.dates.start;
        dataItem.endDate = dataItem.dates.end;

        if (dataItem.excludedTicketingWebsites) {
            dataItem.excludedTicketingWebsiteIds = dataItem.excludedTicketingWebsites.map(a => a.ticketingWebsiteId);
        }
        else {
            dataItem.excludedTicketingWebsiteIds = null;
        }

        if (dataItem.loginShortingBlackoutDatesKey) {
            updateLoginShortingBlackoutDates(dataItem);
        }
        else {
            addLoginShortingBlackoutDates(dataItem);
        }
    }

    const cancel = (dataItem) => {
        setOpenForm(false);
    };

    const enterEdit = (dataItem) => {
        if (dataItem.beginDate && dataItem.endDate) {
            dataItem.dates = {
                start: new Date(dataItem.beginDate),
                end: new Date(dataItem.endDate),
            }
        }

        if (dataItem.excludedTicketingWebsiteIds) {
            var excludedTicketingWebsites = [];
            dataItem.excludedTicketingWebsiteIds.forEach(excludedTicketingWebsiteId => {
                var excludedTicketingWebsite = ticketingWebsites.find(ticketingWebsite => ticketingWebsite.ticketingWebsiteId === excludedTicketingWebsiteId);
                excludedTicketingWebsites.push(excludedTicketingWebsite);
            });
            dataItem.excludedTicketingWebsites = excludedTicketingWebsites;
        }

        setEditItem(dataItem);
        setOpenForm(true);
    };

    const addNew = () => {
        setEditItem({
            venueEventKey: props.venueEventKey,
            isActive: true,
        });
        setOpenForm(true);
    };

    useEffect(() => {
        if (props.loginKey) {
            getTicketingWebsites();
            getLoginShortingBlackoutDates();
        }
    }, []);

    return (
        <>
            {isLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={loginShortingBlackoutDates}
                        dataItemKey={"loginShortingBlackoutDatesKey"}
                        resizable={true}
                        scrollable="none"
                    >
                        <GridToolbar>
                            <Button
                                title={"Add New"}
                                themeColor={"primary"}
                                icon="plus"
                                onClick={addNew}
                            >
                                Add New
                            </Button>
                        </GridToolbar>
                        <Column field="beginDate" title={"Begin date"} />
                        <Column field="endDate" title={"End date"} />
                        <Column field="excludedTicketingWebsiteNamesCsv" title={"Excluded websites"} />
                        <Column cell={MyCommandCell} width="150px" />
                    </Grid>
                    {openForm &&
                        <AdministratorLoginShortingBlackoutDatesForm
                            cancel={cancel}
                            save={save}
                            item={editItem}
                            ticketingWebsites={ticketingWebsites}
                        />
                    }
                </>
            ) : <></>)
            }
        </>
    );
}